import { Customer } from '../../models/customer';
import { User } from '../../models/user';

export function formatUserName(
  user: Pick<User, 'firstName' | 'lastName'>,
  customer?: Customer | null,
): string {
  if (!user) return '';

  // If customer has prioritizeEmployeeLastName flag set to true, show lastName first
  if (customer?.prioritizeEmployeeLastName) {
    return `${user.lastName} ${user.firstName}`;
  }

  // Default format: firstName lastName
  return `${user.firstName} ${user.lastName}`;
}
